import { StoreState } from 'store/store';
import { Slice } from '../types';
import actions from './resources.actions';
import reducers, { ResourceMutations } from './resources.reducer';
import { ResourcesState, initialState } from './resources.state';

const slice: Slice<StoreState, ResourcesState, ResourceMutations> = {
  name: 'resources',
  state: initialState,
  reducers,
  actions,
};

export default slice;
